var videos = document.querySelectorAll('.bg-video');

const smoothLeatherSectionMobile = () => {
  document.getElementById('smooth-leather-section-mobile').style.display = 'block'
  document.getElementById('suede-section-mobile').style.display = 'none'
  document.getElementById('canvas-section-mobile').style.display = 'none'

  videos.forEach(function(video) {
    video.pause();
  });
};

const suedeSectionMobile = () => {
  document.getElementById('suede-section-mobile').style.display = 'block'
  document.getElementById('canvas-section-mobile').style.display = 'none'
  document.getElementById('smooth-leather-section-mobile').style.display = 'none'
  
  videos.forEach(function(video) {
    video.pause();
  });
}

const canvasSectionMobile = () => {
  document.getElementById('canvas-section-mobile').style.display = 'block'
  document.getElementById('suede-section-mobile').style.display = 'none'
  document.getElementById('smooth-leather-section-mobile').style.display = 'none'
    
  videos.forEach(function(video) {
    video.pause();
  });
}

const smoothLeather = () => {
  document.getElementById('smooth-leather-section').style.display = 'flex'
  document.getElementById('suede-section').style.display = 'none'
  document.getElementById('canvas-section').style.display = 'none'
    
  videos.forEach(function(video) {
    video.pause();
  });
}

const suedeSection = () => {
  document.getElementById('suede-section').style.display = 'flex'
  document.getElementById('smooth-leather-section').style.display = 'none'
  document.getElementById('canvas-section').style.display = 'none'
    
  videos.forEach(function(video) {
    video.pause();
  });
}
 
const canvasSection = () => {
  document.getElementById('canvas-section').style.display = 'flex'
  document.getElementById('suede-section').style.display = 'none'
  document.getElementById('smooth-leather-section').style.display = 'none'
    
  videos.forEach(function(video) {
    video.pause();
  });
}


// -- VIDEO --
const videoElements = document.querySelectorAll('.care__video');
videoElements.forEach( function(videoElement) {
  let checkFirst = true;
  const bgVideoElement = videoElement.querySelector('.bg-video');
  const buttonElement = videoElement.querySelector('.care__video__button');
  videoElement.addEventListener('click', function() {
    videos.forEach(function(video) {
      if(!video.paused && bgVideoElement != video){
        video.pause();
      }
    });

    bgVideoElement.classList.add('is-play');
    if(bgVideoElement.classList.contains('is-play') && checkFirst){  
      console.log(bgVideoElement);
      checkFirst = false;
      buttonElement.remove();
    }
  });
});